import { ReactComponent as LogoSvg } from './logo.svg';

export default LogoSvg;
